export default __webpack_public_path__ + "static/media/AttributeIcon.a766ba28.svg";